import { View } from 'components/View'
import React from 'react'

function FormButtons (props) {
  return (
    <View
      style={{
        flexDirection: View.DIRECTION.ROW,
        justifyContent: props.justifyContent || 'center',
        alignItems: 'center',
        padding: '0',
        margin: '1.33em 0'
      }}
    >
      {props.children}
    </View>
  )
}

FormButtons.propTypes = View.propTypes
FormButtons.JUSTIFY = View.JUSTIFY

export default FormButtons
